export default __webpack_public_path__ + "static/media/505.51bad84e.svg";